const actionItemsStyle = theme => ({
    disabledText: { color: theme.palette.text.disabled },
    disabledAction: { cursor: 'default', pointerEvents: 'none' },
});

export default actionItemsStyle;
